const REDACTED_VALUE = '[REDACTED]';
const SENSITIVE_KEYS = [
  'token',
  'witnesstoken',
  'authorization',
  'password',
  'secret',
  'cookie',
  'pincode',
  'email',
  'fullname',
  'patient',
  'mrn',
  'ssn',
  'dob'
];

const isPlainObject = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null && !Array.isArray(value);

const shouldRedact = (key: string): boolean =>
  SENSITIVE_KEYS.some(sensitiveKey => key.toLowerCase().includes(sensitiveKey));

export function redactSensitiveData<T>(value: T): T {
  if (Array.isArray(value)) {
    return value.map(item => redactSensitiveData(item)) as T;
  }

  if (!isPlainObject(value)) {
    return value;
  }

  const redacted: Record<string, unknown> = {};

  Object.entries(value).forEach(([key, entryValue]) => {
    if (shouldRedact(key)) {
      redacted[key] = REDACTED_VALUE;
      return;
    }

    redacted[key] = redactSensitiveData(entryValue);
  });

  return redacted as T;
}
